import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  FiHome, 
  FiUsers, 
  FiSettings, 
  FiFileText, 
  FiTrendingUp,
  FiAlertCircle,
  FiLogOut,
  FiChevronLeft,
  FiChevronRight,
  FiMenu,
  FiDollarSign,
  FiActivity,
  FiClipboard
} from 'react-icons/fi';
import { 
  MdDashboard, 
  MdGavel, 
  MdFeedback,
  MdNotificationsActive
} from 'react-icons/md';

const AdminSidebar = ({ isCollapsed, setIsCollapsed }) => {
  const location = useLocation();

  // Color scheme from requirements
  const colors = {
    primary: '#085e53',    // Main Background
    secondary: '#267c77',  // Selection/Hover
    text: '#FFFFFF'
  };

  const menuItems = [
    {
      path: '/admin/dashboard',
      name: 'मुख्य डॅशबोर्ड',
      icon: <MdDashboard size={20} />
    },
    {
      path: '/admin/gram-panchayat',
      name: 'ग्रामपंचायत व्यवस्थापन',
      icon: <FiHome size={20} />
    },
    {
      path: '/admin/applications',
      name: 'अर्ज निरीक्षण',
      icon: <FiFileText size={20} />
    },
    {
      path: '/admin/financial',
      name: 'आर्थिक निरीक्षण',
      icon: <FiDollarSign size={20} />
    },
    {
      path: '/admin/users',
      name: 'वापरकर्ता व्यवस्थापन',
      icon: <FiUsers size={20} />
    },
    {
      path: '/admin/reports',
      name: 'अहवाल विभाग',
      icon: <FiTrendingUp size={20} />
    },
    {
      path: '/admin/complaints',
      name: 'तक्रार व अभिप्राय',
      icon: <MdFeedback size={20} />
    },
    {
      path: '/admin/audit-logs',
      name: 'लेखा नोंदी',
      icon: <FiClipboard size={20} />
    },
    {
      path: '/admin/notifications',
      name: 'सूचना व इशारे',
      icon: <MdNotificationsActive size={20} />
    },
    {
      path: '/admin/settings',
      name: 'सेटिंग्ज',
      icon: <FiSettings size={20} />
    }
  ];

  const handleLogout = () => {
    localStorage.removeItem('userRole');
    localStorage.removeItem('authToken');
    window.location.href = '/login';
  };

  return (
    <div 
      className={`${isCollapsed ? 'w-20' : 'w-72'} min-h-screen transition-all duration-300 relative flex flex-col shadow-xl`}
      style={{ backgroundColor: colors.primary, color: colors.text }}
    >
      {/* Title Section */}
      <div className="p-4 flex items-center justify-center border-b border-white/20">
        {!isCollapsed ? (
          <h1 className="text-xl font-bold text-center leading-tight">
            ग्राम पंचायत<br/>डिजिटल गव्हर्नन्स
          </h1>
        ) : (
          <h1 className="text-xl font-bold">GP</h1>
        )}
      </div>

      {/* Toggle Button (Mobile/Desktop) */}
      <button
        onClick={() => setIsCollapsed(!isCollapsed)}
        className="absolute -right-3 top-6 bg-white text-teal-800 p-1 rounded-full shadow-lg hover:bg-gray-100 z-50 md:flex hidden"
      >
        {isCollapsed ? <FiChevronRight size={16} /> : <FiChevronLeft size={16} />}
      </button>

      {/* Menu Items */}
      <nav className="flex-1 overflow-y-auto py-4">
        <ul className="space-y-1 px-2">
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 group relative
                    ${isActive ? 'font-bold shadow-md' : 'hover:bg-white/10'}
                  `}
                  style={{ 
                    backgroundColor: isActive ? colors.secondary : 'transparent'
                  }}
                >
                  <span className={`${isActive ? 'text-white' : 'text-white/80'} group-hover:text-white`}>
                    {item.icon}
                  </span>
                  
                  {!isCollapsed && (
                    <span className="whitespace-nowrap overflow-hidden text-ellipsis">
                      {item.name}
                    </span>
                  )}

                  {/* Tooltip for collapsed mode */}
                  {isCollapsed && (
                    <div className="absolute left-full top-1/2 -translate-y-1/2 ml-2 px-2 py-1 bg-gray-800 text-white text-xs rounded opacity-0 group-hover:opacity-100 pointer-events-none whitespace-nowrap z-50">
                      {item.name}
                    </div>
                  )}
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>

      {/* Logout Section */}
      <div className="p-4 border-t border-white/20">
        <button
          onClick={handleLogout}
          className="flex items-center gap-3 w-full px-4 py-3 rounded-lg hover:bg-red-600/20 transition-colors text-red-100 hover:text-white"
        >
          <FiLogOut size={20} />
          {!isCollapsed && <span>बाहेर पडणे (Logout)</span>}
        </button>
      </div>
    </div>
  );
};

export default AdminSidebar;